import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import GenericSection from '../../../../sections/GenericSection/GenericSection';
import Translation from '../../../lang/Translation';
import getShouldShowPudoNotAvailable from '../../../selectors/getShouldShowPudoNotAvailable';
import {isEmailRequired} from '../../../selectors/GuestSelectors';
import {isPudoAvailable} from '../../../selectors/selectors';
import useStyles from './DeliveryAddressSectionWrapper.style';
import DeliveryAddressSection from '../DeliveryAddressSection';

export function DeliveryAddressSectionWrapper(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div data-test="DeliveryAddressSection">
      <GenericSection
        step={props.step}
        isStepActive={props.isStepActive}
        isStepPending={props.isStepPending}
        isStepCollapsed={props.isStepCollapsed}
        id="delivery-address-section-heading"
        headerKey={props.headerKey}
      >
        {!props.isPudoAvailable && props.shouldShowPudoNotAvailable && (
        <p className={classes.clickAndCollectUnavailable}>
          <Translation>checkout.delivery.address.section.unavailable.text</Translation>
        </p>
        )}
        <DeliveryAddressSection
          isStepCollapsed={props.isStepCollapsed}
          step={props.step}
        />
      </GenericSection>
    </div>
  );
}

DeliveryAddressSectionWrapper.propTypes = ({
  step: PropTypes.number.isRequired,
  headerKey: PropTypes.string.isRequired,
  isStepActive: PropTypes.bool.isRequired,
  isStepPending: PropTypes.bool.isRequired,
  isStepCollapsed: PropTypes.bool.isRequired,
  isPudoAvailable: PropTypes.bool.isRequired,
  shouldShowPudoNotAvailable: PropTypes.bool.isRequired,
});

const mapStateToProps = state => ({
  headerKey: isEmailRequired(state) ? 'guest.checkout.address.section.header'
    : 'checkout.delivery.address.legend.text',
  isPudoAvailable: isPudoAvailable(state),
  shouldShowPudoNotAvailable: getShouldShowPudoNotAvailable(state),
});

export default connect(mapStateToProps)(DeliveryAddressSectionWrapper);
